import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type Institution} from './model';

const domain = 'MODALS/CHECKIN_PINCODES';

export const {action: show} = createAction(`${domain}/SHOW`, () => ({}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {
    action: fetchPincodes,
    success: fetchPincodesSuccess,
    failed: fetchPincodesFailed,
} = createAction(
    `${domain}/FETCH_PINCODES`,
    () => ({}),
    (institutions: List<Institution>) => ({institutions}),
);
